module.exports = __webpack_public_path__ + "img/hu4.87d912f7.jpg";